/* eslint-disable max-len */
import React from 'react';
function EventOutlined() {
    return (React.createElement("g", null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19 4H18V2H16V4H8V2H6V4H5C3.89 4 3 4.9 3 6V20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM5 8H19V6H5V8ZM5 20H19V10H5V20ZM14.7701 19L12.1842 17.4393L9.59837 19L10.2846 16.0585L8 14.0794L11.0085 13.8241L12.1842 11.05L13.36 13.8241L16.3684 14.0794L14.0839 16.0585L14.7701 19Z" })));
}
export default EventOutlined;
